import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "dia-title" }, "是否支付成功？", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "dia-des" }, [
  /*#__PURE__*/_createTextVNode(" 支付完成前，请不要关闭此支付验证窗口"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 支付完成后，请根据您的支付情况点击下方按钮 ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pay-tip" }, "如果支付遇到问题，可联系客服解决", -1)

import { ref, watch, Ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PayStatusDialog',
  props: {
  showPayStatus: {
    type: Boolean,
    default: false,
  },
  // 购买类型 1:开通会员 2:单卷购买
  type: {
    type: Number,
    default: 1,
  },
},
  emits: ["paymentResultQuery"],
  setup(__props, { emit }) {

const props = __props;

/**
 * @description:是否支付成功弹窗
 *
 */




watch(props, (prop) => {
  if (prop.showPayStatus) {
    show.value = true;
  }
});

let show: Ref<boolean> = ref(false);

// 未支付
const clickNoPay = () => {
  show.value = false;
  emit("paymentResultQuery", '未支付');
};
// 已支付
const clickHavePay = () => {
  show.value = false;
  emit("paymentResultQuery", '已支付');
};

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(show),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
    center: "",
    "align-center": "",
    "show-close": false,
    "close-on-click-modal": false,
    "destroy-on-close": "",
    "append-to-body": "",
    class: "pay-status-dia"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", { class: "content" }, [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("div", { class: "btns-box" }, [
          _createElementVNode("div", {
            class: "common-btn no-pay",
            onClick: clickNoPay
          }, "未支付"),
          _createElementVNode("div", {
            class: "common-btn have-pay",
            onClick: clickHavePay
          }, "已支付")
        ]),
        _hoisted_3
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})